<template>
  <div :class="$setClasses">
    <card-flex v-if="cardContent"
               :content="cardContent"
               :icon="cardIcon"
               :icon-green="true"
               :mobile-wrapper-column="true"
               class="step-comparator-wrapper__header__card-flex"
               no-box-shadow>
    </card-flex>
    <div v-if="content"
         :class="$vClass('content')"
         v-html="content"></div>
    <div v-if="totalPrice && totalPrice.title"
         :class="[$vClass('total-price'), 'u-is-box']">
      <h3 v-if="totalPrice.title"
          :class="$vClass('total-price__title')"
          v-html="totalPrice.title"></h3>
      <div v-if="totalPrice.arrhes"
           :class="$vClass('total-price__arrhes')"
           v-html="totalPrice.arrhes"></div>
      <div :class="$vClass('total-price__solde')"
           v-html="totalPrice.solde"></div>
    </div>
    <card-flex v-if="footerCardContent && !hasPaidArrhes"
      :class="[$vClass('memo'), 'u-border-none',
      'step-comparator-wrapper__header__card-flex']"
      :content="footerCardContent"
      :icon="stepConfig.footerCard.icon"
      :mobile-wrapper-column="true"
      icon-green
      no-box-shadow/>
    <el-collapse :class="$vClass('collapse')" accordion v-model="activeCollapse">
      <el-collapse-item v-if="hasACard"
                        name="existing_card">
        <template slot="title">
          <h3>{{ getTextVersion('payment.creditCard.title', textParams) }}</h3>
        </template>
        <list-cards-payment />
      </el-collapse-item>
      <el-collapse-item name="add_card" :disabled="!hasACard">
        <template slot="title">
          <h3>{{ $t('payment.addCardPayment.title') }}</h3>
        </template>
        <card-payment ref="cardPayment"
                      :cvc-col="{md: 4, spaceTop: false}"
                      :expiry-col="{md: 4, spaceTop: false}"
                      :loading="loading"
                      :name-col="{md: 24}"
                      :number-col="{md: 16, spaceTop: false}"
                      :billing-address="demand && demand.from_address"
                      suffix-id="-1"
                      @payment-authenticated="paymentAuthenticated"
                      @payment-error="paymentError"
                      @token-change="tokenChange"
                      @update:loading="setLoading($event)" />
      </el-collapse-item>
    </el-collapse>
    <p v-if="stripePaymentError" :class="$vClass('payment_error')">
      {{ stripePaymentError }}
    </p>
    <p :class="$vClass('card__notice')"
       v-html="getTextVersion('payment.creditCard.amountWarningText')"></p>
    <card-flex :class="$vClass('security')"
               :content="$t('payment.security.content')"
               :icon="['fal', 'lock-alt']"
               v-if="!hasPaidArrhes"
               mobile-wrapper-column
               no-box-shadow>
      <template v-slot:after>
        <div :class="$vClass('security__logos')">
          <img v-for="img in $t('payment.security.logo')"
              :alt="img.name"
              :class="$vClass('security__logo')"
              :key="img.image"
              :src="img.image" />
        </div>
      </template>
    </card-flex>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CardFlex from '@/utils/components/CardFlex.vue';
import CardPayment from '@/utils/components/CardPayment.vue';
import ListCardsPayment from '@/components/profile/payment/ListCardsPayment.vue';
import MoveManager from '@/utils/components/MoveManager.vue';

export default {
  name: 'StepPayment',
  nameClassStyle: 'payment',
  extends: MoveManager,
  components: {
    CardFlex,
    CardPayment,
    ListCardsPayment,
  },
  data() {
    return {
      saveCard: false,
      postTokenAction: null,
      stripeToken: null,
      activeCollapse: 'add_card',
      stripePaymentError: null,
    };
  },
  computed: {
    ...mapGetters({
      comparatorConfig: 'configStore/comparatorConfig',
      cardsPayment: 'profileStore/cardsPayment',
      demand: 'demandStore/demand',
      loading: 'configStore/loading',
    }),
    stepConfig() {
      return this.comparatorConfig.payment;
    },
    hasACard() {
      return this.cardsPayment && this.cardsPayment.length;
    },
    content() {
      return this.getTextVersion((this.stepConfig && this.stepConfig.content), this.textParams);
    },
    cardIcon() {
      return this.stepConfig && this.stepConfig.card
        && this.stepConfig.card.icon;
    },
    cardContent() {
      return this.getTextVersion((this.stepConfig && this.stepConfig.card
        && this.stepConfig.card.content), this.textParams);
    },
    footerCardContent() {
      if (this.stepConfig && this.stepConfig.footerCard) {
        return this.getTextVersion(
          this.stepConfig.footerCard && this.stepConfig.footerCard.content,
          this.textParams,
        );
      }
      return '';
    },
    hasPaidArrhes() {
      return this.offer
        && this.offer.arrhes_payment
        && this.offer.arrhes_payment.status === 'succeeded';
    },
    textParams() {
      const overrides = {};
      if (this.hasPaidArrhes) {
        const arrhesAmount = this.offer.arrhes_payment.amountReceived;
        overrides.arrhesAmount = this.$n(arrhesAmount, 'currency');
        overrides.solde = this.$n(this.calcPrice - arrhesAmount, 'currency');
      }
      return {
        ...this.getTextParams,
        ...overrides,
        priceDiff: this.$n(this.priceDiff, 'currency'),
        arrhesPercent: this.arrhesPercent,
        exclTax: this.exclTax ? 'HT' : 'TTC',
      };
    },
    displayPayment() {
      return this.isCommissionaire && this.isIndividual;
    },
    generatedPrice() {
      return this.offer && this.$helpers.offers.getPrice(this.offer, this.exclTax);
    },
    priceDiff() {
      return Math.round((this.generatedPrice + this.servicesPrice - this.ceiling) * 100) / 100;
    },
    totalPrice() {
      if (this.stepConfig && this.stepConfig.options && this.stepConfig.options.totalPrice) {
        return {
          title: this.getTextVersion(this.stepConfig.options.totalPrice.title, this.textParams),
          content: this.getTextVersion(this.stepConfig.options.totalPrice.content,
            this.textParams),
          arrhes: this.getTextVersion(this.stepConfig.options.totalPrice.arrhes,
            this.textParams),
          solde: this.getTextVersion(this.stepConfig.options.totalPrice.solde,
            this.textParams),
        };
      }
      return null;
    },
  },
  async created() {
    // If display add card
    // Get cards
    // Set loading to false
    try {
      this.setStepLoading(true);
      if (this.demand && this.demand.stripe_registered) {
        await this.getCardsPayment();
      }
      // eslint-disable-next-line no-empty
    } catch (error) {
    } finally {
      if (this.hasPaidArrhes) {
        this.activeCollapse = [];
      } else {
        this.activeCollapse = this.cardsPayment && this.cardsPayment.length > 0
          ? 'existing_card'
          : 'add_card';
      }
      this.setStepLoading(false);
    }
  },
  methods: {
    ...mapActions({
      bookOffer: 'offerStore/bookOffer',
      getCardsPayment: 'profileStore/getCardsPayment',
    }),
    nextStep(condition) {
      if (condition !== false) {
        this.$router.push({
          name: 'booking',
          params: {
            id: this.$route.params.id,
          },
          hash: `#${this.comparatorConfig.payment.next.name}`,
        });
      }
    },
    async tokenChange(token, intent) {
      this.stripeToken = token || this.stripeToken;
      if (this.postTokenAction) {
        const result = await this.postTokenAction(
          this.stripeToken,
          intent,
          this.authenticatePayment,
        );
        this.nextStep(result);
      } else {
        this.nextStep();
      }
    },
    paymentAuthenticated(paymentIntent) {
      if (paymentIntent) {
        // TODO
        this.tokenChange(this.stripeToken, paymentIntent);
      } else {
        this.setLoading(false);
      }
      // if (this.isBookingCharge && paymentIntent) {
      //   this.book(null, paymentIntent);
      // }
    },
    submitPayment() {
      if (this.$refs && this.$refs.cardPayment
        && this.$refs.cardPayment.submitFormToCreateToken
        && this.activeCollapse === 'add_card') {
        this.$refs.cardPayment.submitFormToCreateToken();
      } else {
        // WE ARE ALREADY REGISTERED ON STRIPE
        this.tokenChange(null, null);
      }
    },
    bookAction() {
      this.setLoading(true);
      this.postTokenAction = this.book;
      this.submitPayment();
    },
    prebookAction() {
      this.setLoading(true);
      this.postTokenAction = this.preBook;
      this.submitPayment();
    },
    authenticatePayment(intent) {
      if (this.$refs && this.$refs.cardPayment) {
        return this.$refs.cardPayment.authenticatePayment(intent);
      }
      return false;
    },
    paymentError(error) {
      console.log(error);
      this.$helpers.notificationWrapper('stripe', error && error.code);
    },
    onStripeError(errorCode) {
      const errorPath = errorCode && `stripe.error_codes.${errorCode}`;
      if (errorPath) {
        this.stripePaymentError = this.$te(errorPath)
          ? this.$t(errorPath)
          : this.$t('stripe.stripe_error_default_text');
      } else {
        this.stripePaymentError = errorCode;
      }
    },
    setLoading(value) {
      if (value) {
        this.stripePaymentError = null;
      }
      this.$store.commit('configStore/SET_LOADING', value);
    },
    setStepLoading(value) {
      this.$store.commit('configStore/SET_STEP_LOADING', value);
    },
  },
};
</script>

<style scoped lang="scss">
.payment {
  .--margin-bottom-0 {
    margin-bottom: 0;
  }

  &__subtitle {
    display: inline-block;
    margin-right: 10px;
  }
  &__subtitle-legend {
    display: inline-block;
    text-transform: uppercase;
  }
  &__panel {
    padding: 0;
    background-color: $--color-light-grey;
    display: flex;
    flex-direction: column;
    @include breakpoint(mobile) {
      flex-direction: row;
    }
    &__img {
      margin: 20px auto;
    }
    &__text {
      text-align: center;
      margin: 0;
      flex: 1 1 auto;
      @include breakpoint(mobile) {
        text-align: left;
      }
    }
  }
  &__collapse {
    margin: 30px 0;
    border: none;
    :deep(.el-collapse-item.is-disabled) {
      .el-collapse-item__header {
        display: none;
      }
    }
    :deep(.el-collapse-item) {
      h3 {
        font-size: var(--nxt-font-size-large);
      }
    }
  }
  &__wrapper {
    padding: {
      top: 20px;
      bottom: 20px;
    }
  }

  &__total-price {
    margin: 30px 0;

    :deep(.u-dotted) {
      display: none;
    }

    @include breakpoint(tablet) {
      :deep(.u-dotted) {
        display: inherit;
      }
    }

    &__title {
      :deep(span:first-child) {
        font-size: var(--nxt-font-size-default);
      }

      @include breakpoint(tablet) {
        :deep(span:first-child) {
          font-size: inherit;
        }
      }
    }

    &__title, &__arrhes {
      margin-bottom: var(--nxt-space-default);
    }

    &__arrhes, &__solde, &__title {
      text-align: right;
      :deep(p) {
        margin-bottom: 0;
      }

      :deep(i) {
        font-size: 12px;
      }

      :deep(div) {
        display: flex;
        align-items: center;
        justify-content: space-between;

        @include breakpoint(tablet) {
          gap: var(--nxt-space-default);
        }

        > :first-child {
          text-align: left;
        }

        > span:last-child {
          min-width: 140px;
        }

        b {
          flex-shrink: 1;
        }
      }
    }
  }

  &__card {

    &__notice {
      font-size: 14px;
      font-style: italic;
    }
  }
  &__security {
    margin-top: 20px;
    border: solid $--color-primary 1px;

    &__logos {
      display: flex;
      gap: 14px;
    }

    &__logo {
      height: 25px;
    }
  }

  &__payment_error {
    padding-bottom: 15px;
    color: $--color-danger;
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
